import { ReactNode } from "react";
import React from "react";
import {
  ExpandIcon,
  ExpandButtonContainer,
  ExpandLinkContainer,
} from "./styles";
import { VariantProps } from "@phntms/css-components";

export interface ExpandButtonProps {
  expanded?: boolean;
  small?: boolean;
  label?: ReactNode;
}

export const ExpandButton = React.forwardRef(
  (
    {
      expanded,
      small,
      label,
      children,
      ...props
    }: ExpandButtonProps & VariantProps<typeof ExpandButtonContainer>,
    ref,
  ) => {
    return (
      <ExpandButtonContainer
        ref={ref as any}
        {...props}
        {...{ expanded, small }}
      >
        <ExpandIcon /> {label || children}
      </ExpandButtonContainer>
    );
  },
);
ExpandButton.displayName = "ExpandButton";

export const ExpandLink = React.forwardRef(
  (
    {
      expanded,
      small,
      label,
      children,
      ...props
    }: ExpandButtonProps & VariantProps<typeof ExpandLinkContainer>,
    ref,
  ) => {
    return (
      <ExpandLinkContainer ref={ref as any} {...props} {...{ expanded, small }}>
        <ExpandIcon /> {label || children}
      </ExpandLinkContainer>
    );
  },
);
ExpandLink.displayName = "ExpandLink";
